import React, { lazy } from 'react';
import { Button } from './ui/Button';
import { ArrowDownIcon, UsersIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 px-4 md:pt-32 md:pb-20 relative overflow-hidden" data-id="element-85">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4850A]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-86"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-87">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-[#3D2B1F]" data-id="element-88">
          <span className="text-[#D4850A]" data-id="element-89">🍰 Descubre cómo preparar</span>{' '}
          budines irresistibles en casa aunque no sepas cocinar
        </h1>

        <p className="text-xl md:text-2xl text-[#6B5344] mb-6 font-medium max-w-3xl mx-auto" data-id="element-90">
          ¿Te gustaría preparar budines caseros deliciosos, pero siempre pasa lo
          mismo?
        </p>

        {/* Social proof */}
        <div className="flex items-center justify-center gap-2 mb-10 text-[#9B8578]" data-id="element-91">
          <UsersIcon className="w-5 h-5 text-[#D4850A]" data-id="element-92" />
          <span className="text-base font-medium" data-id="element-93">
            +2.400 personas ya descargaron este recetario
          </span>
        </div>

        <div className="relative w-full max-w-4xl mx-auto h-[400px] md:h-[600px] cursor-pointer group mb-12" onClick={() => document.getElementById('compra')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-94">
          {/* Background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#D4850A]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-95"></div>

          {/* Main Book */}
          <img src="https://cdn.magicpatterns.com/uploads/njMAY3XguUNyW1FQwxsdek/0_cover_1.png" alt="Recetario Digital de Budines Caseros" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 md:w-[40%] z-30 drop-shadow-2xl transform transition-transform duration-500 group-hover:scale-105" data-id="element-96" />

          {/* Bonus 1 - Back Left */}
          <img src="https://cdn.magicpatterns.com/uploads/fWrSuNCw9LpS5kCptS5t7g/bono_1.png" alt="Guía de tips para budines esponjosos" loading="lazy" className="absolute top-[40%] left-[15%] md:left-[20%] -translate-y-1/2 w-[35%] md:w-[25%] z-20 drop-shadow-xl -rotate-12 transform transition-transform duration-500 group-hover:-translate-x-4 group-hover:-rotate-6" data-id="element-97" />

          {/* Bonus 2 - Back Right */}
          <img src="https://cdn.magicpatterns.com/uploads/fNMRDkw1z7jg2D6B7MAj2p/bono_2.png" alt="Ideas de glaseados y toppings" loading="lazy" className="absolute top-[40%] right-[15%] md:right-[20%] -translate-y-1/2 w-[35%] md:w-[25%] z-20 drop-shadow-xl rotate-12 transform transition-transform duration-500 group-hover:translate-x-4 group-hover:rotate-6" data-id="element-98" />

          {/* Bonus 3 - Front Left */}
          <img src="https://cdn.magicpatterns.com/uploads/6J65ZVSEbjBSnvsYzg3hwK/bono_3.png" alt="Tabla de conversiones" loading="lazy" className="absolute bottom-[10%] left-[5%] md:left-[10%] w-[40%] md:w-[30%] z-40 drop-shadow-2xl -rotate-6 transform transition-transform duration-500 group-hover:-translate-x-6 group-hover:-rotate-3" data-id="element-99" />

          {/* Bonus 4 - Front Right */}
          <img src="https://cdn.magicpatterns.com/uploads/9n84b1w2G9XGH8gVrcXbGY/bono_4.png" alt="Bonus adicional" loading="lazy" className="absolute bottom-[10%] right-[5%] md:right-[10%] w-[40%] md:w-[30%] z-40 drop-shadow-2xl rotate-6 transform transition-transform duration-500 group-hover:translate-x-6 group-hover:rotate-3" data-id="element-100" />
        </div>

        <Button href="#compra" size="xl" className="group flex flex-col items-center gap-2" data-id="element-101">
          <span data-id="element-102">👉 DESCARGAR AHORA EL RECETARIO</span>
          <span className="text-sm font-normal text-white/70" data-id="element-103">
            Accede inmediatamente al recetario
          </span>
        </Button>

        <div className="mt-6 animate-bounce" data-id="element-104">
          <ArrowDownIcon className="w-6 h-6 text-[#9B8578] mx-auto" data-id="element-105" />
        </div>
      </div>
    </section>;
}